import { useMemo } from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';
import { RelevantDomains } from 'shared/lib/domains';

import { SelectedClass } from '../types';

export interface FiltersState {
  selectedClass: SelectedClass;
  selectedSubjects: RelevantDomains[];
}

const initialState: FiltersState = {
  selectedClass: [],
  selectedSubjects: [],
};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSelectedClass: (state, action: PayloadAction<SelectedClass>) => {
      state.selectedClass = action.payload;
    },
    setSelectedSubjects: (state, action: PayloadAction<RelevantDomains[]>) => {
      state.selectedSubjects = action.payload;
    },
    resetFilters: (state) => {
      state.selectedSubjects = [];
    },
  },
});

export const { setSelectedClass, setSelectedSubjects, resetFilters } =
  filtersSlice.actions;

export const useSelectedClass = () =>
  useAppSelector((state) => state.filters.selectedClass);

export const useSelectedClassKey = () => {
  const selectedClass = useSelectedClass();

  return useMemo(() => selectedClass.map((cl) => cl.classKey), [selectedClass]);
};

export const useSelectedClassGrade = () => {
  const selectedClass = useSelectedClass();

  return useMemo(
    () => [...new Set(selectedClass.map((cl) => cl.grades).flat())],
    [selectedClass],
  );
};

export const useSelectedSubjects = () =>
  useAppSelector((state) => state.filters.selectedSubjects);

export const useFilters = () => useAppSelector((state) => state.filters);

export const filtersReducer = filtersSlice.reducer;
